import { useLang } from "../i18n/LangContext";
import { useAuth } from "../contexts/AuthContext";
import { api } from "../api/client";
import { AUTH } from "../constants/testIds";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Button } from "./ui/button";
import { Globe } from "lucide-react";

export function LanguageSwitcher() {
  const { lang, setLang } = useLang();
  const { user, refresh } = useAuth();

  const choose = async (next) => {
    setLang(next);
    if (user) {
      try {
        await api.patch("/users/me", { preferred_language: next });
        await refresh();
      } catch (err) {
        // The local language switch already applied; persistence is best-effort.
        console.error("persisting language preference failed", err);
      }
    }
  };

  const flag = lang === "id" ? "🇮🇩" : "🇬🇧";
  const label = lang === "id" ? "ID" : "EN";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          data-testid={AUTH.langSwitcher}
          variant="ghost"
          className="text-slate-200 hover:text-white hover:bg-white/5 border border-white/10 rounded-full px-3 h-9 gap-2"
        >
          <Globe className="h-4 w-4" />
          <span className="text-lg leading-none">{flag}</span>
          <span className="text-xs font-semibold tracking-wider">{label}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-[#161923] border-white/10 text-slate-200">
        <DropdownMenuItem
          data-testid={AUTH.langOptionId}
          onClick={() => choose("id")}
          className="focus:bg-white/5 focus:text-white cursor-pointer"
        >
          🇮🇩 Bahasa Indonesia
        </DropdownMenuItem>
        <DropdownMenuItem
          data-testid={AUTH.langOptionEn}
          onClick={() => choose("en")}
          className="focus:bg-white/5 focus:text-white cursor-pointer"
        >
          🇬🇧 English
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
